@import "https://fonts.googleapis.com/css2?family=Chivo:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&family=Nunito:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&family=Poppins:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&display=swap";

/* src/app/core/pages/user-profile/user-profile.page.scss */
.user-profile-info {
  min-height: 240px;
  background: url("./media/cover-picture.png") 0% 0% no-repeat padding-box;
  background-size: 100% 100%;
}
.overlay-container {
  background: rgba(0, 0, 0, 0.3333333333);
  height: 100%;
  color: #ffffff;
  font: normal normal 600 15px/21px Poppins;
}
.user-profile {
  width: 120px;
  height: 120px;
  border: 2px solid #ffffff;
  border-radius: 50%;
}
.btn-edit {
  --background: #6f9d93 !important;
  --padding: 10px !important;
  --border-radius: 8px;
  --color: #ffffff !important;
  --background-hover: #5d8262 !important;
}
.btn-address {
  --background: #444 !important;
  --padding: 10px !important;
  --border-radius: 8px;
  --color: #ffffff !important;
  --background-hover: #0099FF !important;
}
.edit-icon {
  font-size: 14px !important;
}
.address-card {
  width: 100%;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 128, 0, 0.1);
  background-color: #ffffff;
  transition: transform 0.2s ease-in-out;
}
.address-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 128, 0, 0.15);
}
.address-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #ccc;
  background:
    linear-gradient(
      to top left,
      #ffffff,
      #dffce6);
}
.address-type {
  font-size: 18px;
  font-weight: 600;
  color: #567c74;
  font-family: "Poppins", sans-serif;
}
.address-actions ion-button {
  margin-inline-start: 4px;
  margin-inline-end: 4px;
  --padding-start: 6px;
  --padding-end: 6px;
  --border-radius: 50%;
  --box-shadow: none;
  transition: background 0.2s;
}
.address-actions ion-icon {
  font-size: 18px;
}
.address-card-content ion-item.address-line {
  --padding-start: 0px;
  --padding-end: 0px;
  --inner-padding-end: 0px;
  --inner-padding-start: 0px;
  font-size: 15px;
}
.address-card-content ion-label {
  display: flex;
  flex-direction: row;
  font-family: "Nunito", sans-serif;
}
.address-card-content ion-text[color=medium] {
  font-weight: 600;
  margin-right: 10px;
  color: #555 !important;
  margin-bottom: 2px;
}
.address-line {
  margin-bottom: 0px;
  color: #555;
}
/*# sourceMappingURL=user-profile.page.css.map */
